import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import { T_Api_Paginated, T_Api_Success_Res } from "./api.types";
import { NotificationCategory, T_Notification } from "dtos/notifications.dto";

export const notificationService = {
  useGetNotifications: (params: {
    page: number;
    limit: number;
    search?: string;
    category: "all" | NotificationCategory;
    actionableOnly: boolean;
    sortBy?: string;
    sortOrder?: -1 | 1;
    appKey?: string;
  }) => {
    const queryParams = new URLSearchParams({
      page: params.page.toString(),
      limit: params.limit.toString(),
    });

    if (params.search) queryParams.set("search", params.search);
    if (params.category !== "all") queryParams.set("category", params.category);
    if (params.actionableOnly) queryParams.set("actionableOnly", "true");
    if (params.sortBy) queryParams.set("sortBy", params.sortBy);
    if (params.sortOrder) queryParams.set("sortOrder", String(params.sortOrder));
    if (params.appKey) queryParams.set("appKey", params.appKey);

    return useQuery({
      queryKey: ["notifications", params],
      queryFn: async () => {
        const res = await api.get(`/notifications/all?${queryParams.toString()}`);

        return res.data as T_Api_Success_Res<
          T_Api_Paginated<{
            title: string;
            notification: T_Notification[];
          }>
        >;
      },
      refetchInterval: 15 * 1000,
    });
  },
  useResolveCardActivity: () => {
    return useMutation({
      mutationFn: async ({
        activityId,
        ...body
      }: {
        activityId: string;
        applicationId: string;
        templateId: string;
        loanId?: string;
        overrides: Record<string, string>;
      }) => {
        const res = await api.post(`/board/activity/${activityId}/resolve`, body);
        return res.data as T_Api_Success_Res<{ resolvedTo: string[] }>;
      },
    });
  },
};
